/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as PNDISBLayerSpec } from '../../../../layer/preset/bar/positiveAndNegativeDoubleIndicatorSumBar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface PNDISBLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type PNDISBLayerType = StandardChartLayerSpec & PNDISBLayerSpec & PNDISBLayerTypeWithFields;

// 创建正负双指标求和条形图数据类型验证器
const validatePNDISBDataTypes = createDataTypeValidator(
  'positiveAndNegativeDoubleIndicatorSumBar',
  [
    { field: 'x', type: ['string', 'date'] },
    { field: 'y', type: 'number' },
    { field: 'y2', type: 'number' }
  ]
);

// 创建正负双指标求和条形图编码验证器
const validatePNDISBEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'y2' }
]);

// 额外的检查函数
const additionalPNDISBChecks = (layer: PNDISBLayerType, data: Data) => {
  const targetType = 'positiveAndNegativeDoubleIndicatorSumBar';

  // 数据量检查：建议至少有2条数据才能体现对比效果
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];
  if (values.length < 2) {
    utils.logger.warn(
      'warning',
      `The "${targetType}" chart works best with at least 2 data points for comparison`
    );
  }
};

// 创建并导出正负双指标求和条形图处理器
export const positiveAndNegativeDoubleIndicatorSumBar = createLayerProcessor<PNDISBLayerType>(
  'positiveAndNegativeDoubleIndicatorSumBar',
  validatePNDISBEncoding,
  validatePNDISBDataTypes,
  additionalPNDISBChecks
);
